<script>
    import { useNavigate } from 'svelte-navigator';
    import { onMount } from 'svelte';
    import { dateShort, currencyUSD, numberFormatted, dateRelative } from '../utils/conv';
    import { headerDisplayStore } from '../stores/General';
    import { campaignDetailStore } from '../stores/Campaign';
   import Button from '../components/button/RouteButton.svelte';
import CustomIcon from '../components/CustomIcon.svelte';

    const navigate = useNavigate();

    onMount(() => {
        headerDisplayStore.SetTitle('Campaign Details');
    });

    const edit = () => {
        navigate(`/campaign/edit/${$campaignDetailStore.campaign_id}`);
    }

    const getStatusClass = (status) => {
        switch (status) {
            case 'ended':
                return 'bg-custom-light-green text-custom-green'
                break;
            case 'live':
                return 'bg-custom-light-red text-custom-red'
                break;
            default:
                return ''
                break;
        }
    }
</script>
<div class="w-full sm:px-6">
    <div class="py-2 md:py-2">
        <div class="sm:flex items-center justify-between">
            <div>
                <Button name="Go Back" route={-1} goback={true} />
    
            </div>
        </div>
    </div>
</div>

<div class="rounded mx-16 my-4 pb-24">
    <div class="px-16 py-7 pb-40 flex flex-wrap bg-white rounded-2xl justify-between">
        <div class="mx-1.5 grow">
            <div class="flex mb-10">
                <div class="w-40 text-sm font-bold pr-12">
                    Campaign Name
                </div>
                <div class="text-xs pt-1">
                    {$campaignDetailStore?.name || '-'}
                </div>
            </div>
            <div class="flex mb-10">
                <div class="w-40 text-sm font-bold pr-12">
                    Campaign Details
                </div>
                <div class="text-xs pt-1">
                    {$campaignDetailStore?.description || '-'}
                </div>
            </div>
            <div class="flex mb-10">
                <div class="w-40 text-sm font-bold pr-12">
                    Start At
                </div>
                <div class="text-xs pt-1">
                    {dateShort($campaignDetailStore.start_at)}
                </div>
            </div>
            <div class="flex mb-10">
                <div class="w-40 text-sm font-bold pr-12">
                    End At
                </div>
                <div class="text-xs pt-1">
                    {dateShort($campaignDetailStore.end_at)}
                </div>
            </div>
            <div class="flex mb-10">
                <div class="w-40 text-sm font-bold pr-12">
                    Status
                </div>
                <div class="text-xs pt-1">
                    <div class="w-20 text-center rounded-3xl capitalize {getStatusClass($campaignDetailStore?.status)}">
                        {$campaignDetailStore?.status || '-'}
                    </div>
                </div>
            </div>
            <div class="flex mb-10">
                <div class="w-40 text-sm font-bold pr-12">
                    Budget
                </div>
                <div class="text-xs pt-1">
                    {currencyUSD($campaignDetailStore?.budget || 0)}
                </div>
            </div>
            <div class="flex mb-10">
                <div class="w-40 text-sm font-bold pr-12">
                    Impressions
                </div>
                <div class="text-xs pt-1">
                    {numberFormatted($campaignDetailStore?.impressions || 0)}
                </div>
            </div>
            <div class="flex mb-10">
                <div class="w-40 text-sm font-bold pr-12">
                    Target Price
                </div>
                <div class="text-xs pt-1">
                    {currencyUSD($campaignDetailStore?.target_price || 0)}
                </div>
            </div>
            <div class="flex mb-10">
                <div class="w-40 text-sm font-bold pr-12">
                    Updated at
                </div>
                <div class="text-xs pt-1">
                    {dateRelative($campaignDetailStore?.updated_at)}
                </div>
            </div>
        </div>
        <div class="pt-28 grow-0 text-center">
            <button
                type="button"
                on:click={() => edit()}
                class="w-72 h-14 relative inline-flex items-center justify-center px-1 py-2 rounded-md border shadow-nv border-custom-orange bg-custom-orange text-sm font-medium text-white hover:bg-custom-orange focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-600 focus:border-blue-600"
            >
                
                <CustomIcon width="19" height="20" name="edit_cd"/>
                <span class="ml-4">Edit </span>
            </button>
        </div>
    </div>
</div>
